import React from 'react';
import ModulePMR from '../components/ModulePMR';

const EvenementsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white py-16 px-4 border-b-4 border-[#e2b13c]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c]">
            Mise à disposition, Mariages et Services Business
          </h1>
          <h2 className="text-2xl font-semibold mb-8 text-gray-200">
            Un service discret et raffiné pour vos moments d'exception
          </h2>
        </div>
      </div>

      {/* Contenu */}
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg p-10 text-gray-200 mb-12">
          <p className="text-lg leading-relaxed mb-6">
            Pour un mariage, un séminaire ou un circuit touristique : votre chauffeur et son véhicule restent à votre entière disposition.
          </p>
          <p className="text-lg leading-relaxed text-[#e2b13c] font-semibold">
            Pour les entreprises, offrez à vos collaborateurs un trajet tout confort avec une facturation simplifiée.
          </p>
        </div>

        {/* Services */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#0f172a] rounded-lg border-2 border-[#e2b13c] overflow-hidden">
            {/* Photo de mariage */}
            <div className="relative h-48 overflow-hidden">
              <img 
                src="/images/voiture-mariage.jpg" 
                alt="Voiture de mariage VTC des Weppes" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8 text-center">
              <div className="text-5xl mb-4">💍</div>
              <h3 className="text-xl font-bold text-[#e2b13c] mb-4">Mariages</h3>
              <ul className="text-gray-300 text-left space-y-2">
                <li>• Transport des mariés</li>
                <li>• Mise à disposition journée</li>
                <li>• Véhicules de prestige</li>
                <li>• Décoration personnalisée</li>
              </ul>
            </div>
          </div>

          <div className="bg-[#0f172a] rounded-lg border-2 border-[#e2b13c] overflow-hidden">
            {/* Photo salle de conférence */}
            <div className="relative h-48 overflow-hidden">
              <img 
                src="/images/salle-conference.jpg" 
                alt="Séminaire entreprise VTC des Weppes" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8 text-center">
              <div className="text-5xl mb-4">🏛️</div>
              <h3 className="text-xl font-bold text-[#e2b13c] mb-4">Séminaires</h3>
              <ul className="text-gray-300 text-left space-y-2">
                <li>• Transport de groupes</li>
                <li>• Navettes entreprise</li>
                <li>• Facturation centralisée</li>
                <li>• Discrétion assurée</li>
              </ul>
            </div>
          </div>

          <div className="bg-[#0f172a] p-8 rounded-lg border-2 border-[#e2b13c] text-center">
            <div className="text-5xl mb-4">🎉</div>
            <h3 className="text-xl font-bold text-[#e2b13c] mb-4">Événements Privés</h3>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• Soirées & Galas</li>
              <li>• Anniversaires</li>
              <li>• Circuits touristiques</li>
              <li>• Tout type d'événement</li>
            </ul>
          </div>
        </div>

        {/* Formules */}
        <div className="mt-12 bg-gradient-to-r from-[#0f172a] to-[#1e293b] border-2 border-[#e2b13c] rounded-lg p-8">
          <h3 className="text-2xl font-bold text-[#e2b13c] mb-6 text-center">Formules Mise à Disposition</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-[#1e293b] p-6 rounded-lg text-center border border-[#e2b13c]">
              <div className="text-3xl font-black text-[#e2b13c] mb-2">1h</div>
              <div className="text-gray-300">Départ 80€</div>
            </div>
            <div className="bg-[#1e293b] p-6 rounded-lg text-center border border-[#e2b13c]">
              <div className="text-3xl font-black text-[#e2b13c] mb-2">2h</div>
              <div className="text-gray-300">Départ 160€</div>
            </div>
            <div className="bg-[#1e293b] p-6 rounded-lg text-center border border-[#e2b13c]">
              <div className="text-3xl font-black text-[#e2b13c] mb-2">3h</div>
              <div className="text-gray-300">Départ 240€</div>
            </div>
            <div className="bg-[#1e293b] p-6 rounded-lg text-center border border-[#e2b13c]">
              <div className="text-3xl font-black text-[#e2b13c] mb-2">4h</div>
              <div className="text-gray-300">Départ 320€</div>
            </div>
          </div>
          <p className="text-sm text-gray-400 text-center mt-6 italic">Tarifs indicatifs. Devis personnalisé sur demande.</p>
        </div>

        {/* NOUVEAU : Formulaire de demande détaillé */}
        <div className="mt-16">
          <h3 className="text-3xl font-bold text-[#e2b13c] mb-8 text-center">
            Demande de Devis Personnalisé
          </h3>
          <ModulePMR />
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <div className="bg-[#e2b13c] text-[#0f172a] py-4 px-8 rounded-lg inline-block">
            <p className="text-xl font-bold mb-2">Ou contactez-nous directement</p>
            <a href="tel:0695731320" className="text-2xl font-black hover:underline">
              📞 06 95 73 13 20
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvenementsPage;